export default {
  NoUpload: "UPLOAD_NOUPLOAD",
  FetchingPresignedUrl: "UPLOAD_FETCHURL",
  UploadingFile: "UPLOAD_UPLOADING",
};
